export function detectSkill(text: string) {
  if (/^\[\[(.*?)\]\]$/.test(text)) {
    return RegExp.$1
  }
  return null
}
